module.exports = __webpack_public_path__ + "img/09_rki.f16a6066.jpg";